module.exports = __webpack_public_path__ + "gift1.svg?837be68566cb024eddf6f435ab12151c";